import React from 'react';
import { Exercise } from '../data/exercises';
interface ExerciseCardProps {
  exercise: Exercise;
}
const ExerciseCard: React.FC<ExerciseCardProps> = ({
  exercise
}) => {
  return <div className="p-6 pt-4" data-id="element-8">
      <h2 className="text-2xl font-bold mb-2" data-id="element-9">{exercise.name}</h2>
      <p className="text-gray-600 mb-4" data-id="element-10">{exercise.reps} reps</p>
      <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden mb-4 flex items-center justify-center" data-id="element-11">
        {exercise.imageUrl ? <img src={exercise.imageUrl} alt={`Demonstration of ${exercise.name}`} className="w-full h-full object-cover" data-id="element-12" /> : <div className="text-gray-500 text-center p-4" data-id="element-13">
            <p data-id="element-14">Exercise demonstration</p>
            <p className="text-sm" data-id="element-15">Visual guidance would appear here</p>
          </div>}
      </div>
      <div className="bg-gray-100 p-4 rounded-lg" data-id="element-16">
        <h3 className="font-semibold mb-2" data-id="element-17">Instructions:</h3>
        <p data-id="element-18">
          {exercise.instructions || 'Perform the exercise with proper form following the visual guidance.'}
        </p>
      </div>
    </div>;
};
export default ExerciseCard;